import { getApiBaseUrl } from '@/config/env'

// Build an absolute-or-relative URL for an auth endpoint. Mirrors the axios
// client's base: empty (same-origin, reverse-proxied) when VITE_API_USE_RELATIVE,
// otherwise the configured API origin. Used for calls made with bare axios
// (e.g. token refresh) that must bypass the client's 401-refresh interceptor.
export function authEndpointUrl(path) {
  const base = getApiBaseUrl()
  return `${base}${path}`
}
